import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';

import { NotifyService } from '../../services/services';

@Component({
  selector: 'app-notify',
  templateUrl: './notify.component.html',
  styleUrls: ['./notify.component.css']
})
export class NotifyComponent implements OnInit {

  private sub: any;
  public errorTitle: string;
  public errorMessage: string;
  public display: boolean;

  constructor(
    private notifyService: NotifyService,
    private router: Router,
    private route: ActivatedRoute) {

    this.notifyService.onNotifyChange.subscribe((notification) => {
      this.errorTitle = notification.title;
      this.errorMessage = notification.message;
      this.display = true;
    });

  }

  ngOnInit() {
  }

  refreshPage() {
    window.location.reload();
  }



}



// WEBPACK FOOTER //
// D:/a/1/s/src/app/components/notify/notify.component.ts